const initialState = {
  visible: null,
  variant: 'default',
  payload: null,
};

export default initialState;
